import { render, staticRenderFns } from "./DashCabinet.vue?vue&type=template&id=da0d0c3c&"
import script from "./DashCabinet.vue?vue&type=script&lang=js&"
export * from "./DashCabinet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports